<template>
	<div class="main">
<!-- 		<div style="width: 600px; margin: 0 auto;">
			<img src="../../../static/building.png" style="height: 100%; width: 100%;" alt="">
		</div> -->
		<div class="hyzj-news-block">
			<div class="hyzj-news-list">
				<div class="hyzj-news-box" v-for="(item, index) in dataList" :key="index" @click="toDetails(item.id)">
					<div class="news-left">
						<img :src="$imgUrl + item.listImgPc" alt="">
					</div>
					<div class="news-right">
						<div class="news-title">
							{{item.title}}
						</div>
						<div class="news-content">
							{{item.shortTitle}}
						</div>
						<div class="news-time">
							{{$moment(item.createdTime).format('YYYY/MM/DD')}}
						</div>
					</div>
				</div>
			</div>
			<page :pageObj="params" @getDataList="getData"></page>
		</div>
	</div>
</template>

<script>
	import Page from '@/components/Page.vue'
	export default {
		name: '',
		components: {
			Page
		},
		data () {
			return {
				params: {
					current: 1,
					size: 4,
					channelId: this.$store.state.channelId,
					releaseTerrace: "releasePc"
				},
				dataList: []
			}
		},
		mounted() {
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../../static/top_banner_4.png'
		},
		methods: {
			getData(dataList) {
				this.dataList = dataList
			},
			toDetails(hd_id) {
				this.$router.push({
					path: '/jchg_details',
					query: {
						hd_id: hd_id
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.main {
		width: 74%;
		margin: 18px 13% 80px;
		.hyzj-news-block {
			margin: 0 0 40px;
			.hyzj-news-list {
				margin-bottom: 20px;
				.hyzj-news-box {
					display: flex;
					justify-content: space-between;
					width: 100%;
					padding: 20px;
					margin: 0 0 20px;
					border-bottom: 1px solid #B4B4B4;
					cursor: pointer;
					.news-left {
						width: 25%;
						img {
							width: 100%;
							height: 100%;
						}
					}
					.news-right {
						width: 70%;
						text-align: left;
						display: flex;
						flex-direction: column;
						justify-content: space-around;
						.news-title {
							color: #264EA7;
							font-size: 12px;
							height: 30px;
							line-height: 30px;
						}
						.news-content {
							margin-top: 15px;
							color: #333333;
							font-size: 11px;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							line-clamp: 2;
							-webkit-box-orient: vertical;
						}
						.news-time {
							margin-top: 10px;
							color: #686868;
							font-size: 9px;
						}
					}
				}
				.hyzj-news-box:hover {
					display: flex;
					justify-content: space-between;
					width: 100%;
					padding: 20px;
					margin: 0 0 20px;
					border: 1px solid #EDD68E;
					cursor: pointer;
					.news-left {
						width: 25%;
						img {
							width: 100%;
							height: 100%;
						}
					}
					.news-right {
						width: 70%;
						text-align: left;
						display: flex;
						flex-direction: column;
						justify-content: space-around;
						.news-title {
							color: #264EA7;
							font-size: 12px;
							height: 30px;
							line-height: 30px;
						}
						.news-content {
							margin-top: 15px;
							color: #333333;
							font-size: 11px;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							line-clamp: 2;
							-webkit-box-orient: vertical;
						}
						.news-time {
							margin-top: 10px;
							color: #686868;
							font-size: 9px;
						}
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/teaching_activities/jchg.vue